import { RovoAgentAri } from '@atlassian/ari/rovo/agent';

/**
 * The Rovo Agent this MCP consent is for: the one signed `resources` entry that
 * parses as a Rovo Agent ARI. Returned verbatim so AGG receives the server's
 * value unchanged. Absent, none, or more than one Agent ARI means a normal MCP
 * consent (the server rejects more than one on resume).
 */
export function getAgentMcpResource(
  resources: readonly string[] | undefined,
): string | undefined {
  const agentResources = (resources ?? []).filter(isRovoAgentAri);
  return agentResources.length === 1 ? agentResources[0] : undefined;
}

function isRovoAgentAri(resource: string): boolean {
  try {
    RovoAgentAri.parse(resource);
    return true;
  } catch {
    return false;
  }
}
